// @flow
import createIcon from './utils/createIcon'

export default createIcon({
  iconName: 'swap',
  icon: [
    512,
    512,
    null,
    null,
    'M508.5 168.5L408 268.5a12 12 0 0 1-17 0l-19.6-19.6a12 12 0 0 1 .2-17.2l51.2-47.7H12a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h411l-51.3-47.7a12 12 0 0 1-.2-17.2l19.6-19.6a12 12 0 0 1 17 0l100.4 100a12 12 0 0 1 0 17zm-505 192l100.4 100a12 12 0 0 0 17 0l19.6-19.6a12 12 0 0 0-.2-17.2L89.1 376H500a12 12 0 0 0 12-12v-24a12 12 0 0 0-12-12H89l51.3-47.7a12 12 0 0 0 .2-17.2l-19.6-19.6a12 12 0 0 0-17 0L3.5 343.5a12 12 0 0 0 0 17z',
  ],
})
